import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import SupabaseSignInForm from '@auth/services/supabase/SupabaseSignInForm';

function SignInPageView() {
	return (
		<div className="flex min-w-0 flex-auto flex-col items-center sm:flex-row sm:justify-center md:items-start md:justify-start">
			<Paper className="h-full w-full px-4 py-2 sm:h-auto sm:w-auto sm:rounded-xl sm:p-12 sm:shadow-sm md:flex md:h-full md:w-1/2 md:items-center md:justify-end md:rounded-none md:p-16 md:shadow-none ltr:border-r-1 rtl:border-l-1">
				<div className="mx-auto flex w-full max-w-80 flex-col gap-8 sm:mx-0 sm:w-80">
					<div className="w-full">
						<Typography className="text-4xl leading-[1.25] font-extrabold tracking-tight">
							Skipper's Locker Admin
						</Typography>
						<Typography
							className="mt-1 font-medium"
							color="text.secondary"
						>
							Sign in to the admin panel
						</Typography>
					</div>

					<SupabaseSignInForm />
				</div>
			</Paper>

			<Box
				className="relative hidden h-full flex-auto items-center justify-center overflow-hidden p-16 md:flex lg:px-28"
				sx={{
					backgroundColor: 'primary.dark',
					color: 'primary.contrastText'
				}}
			>
				<svg
					className="pointer-events-none absolute inset-0"
					viewBox="0 0 960 540"
					width="100%"
					height="100%"
					preserveAspectRatio="xMidYMax slice"
					xmlns="http://www.w3.org/2000/svg"
				>
					<Box
						component="g"
						className="opacity-5"
						fill="none"
						stroke="currentColor"
						strokeWidth="100"
					>
						<circle
							r="234"
							cx="196"
							cy="23"
						/>
						<circle
							r="234"
							cx="790"
							cy="491"
						/>
					</Box>
				</svg>

				<div className="relative z-10 w-full max-w-4xl">
					<div className="text-7xl leading-none font-bold text-gray-100">
						<div>Skipper's Locker</div>
						<div>Admin Panel</div>
					</div>
					<div className="mt-6 text-lg leading-6 tracking-tight text-gray-400">
						Manage the marine parts catalog, review merges, and watch the ingestion pipeline for Skipper's Locker.
					</div>
				</div>
			</Box>
		</div>
	);
}

export default SignInPageView;
